
import "core-js/stable";
import "regenerator-runtime/runtime";
// eslint-disable-next-line import/order
import 'intl'; // 兼容IE10, 最好在头部引入...
// global.Intl = require('intl'); //这个目测可以不用
// window.Intl = require('intl'); //这个目测可以不用

import React from 'react';

// 载入默认全局样式 normalize 、.clearfix 和一些 mixin 方法等
import '@icedesign/base/reset.scss';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { IntlContainer } from './i18n';
import router from './router';
import store from './store/store';

const ICE_CONTAINER = document.getElementById('ice-container');
if (!ICE_CONTAINER) {
  throw new Error('当前页面不存在 <div id="ice-container"></div> 节点.');
}

ReactDOM.render(
  <Provider store={store}>
    <IntlContainer>{router}</IntlContainer>
  </Provider>,
  ICE_CONTAINER
);

  